import * as React from 'react'
import * as Assets from '../../../assets/Assets'
import * as Body from './Body'
import { Link } from 'react-router-dom'
import { withCookies } from 'react-cookie'
import Socket from '../../../Socket/socket-init';
import Loader from './Loader';

class Unsubscribe extends React.Component<{}, {mobileMenu: boolean, popup: boolean}> {

  constructor(props) {
    super(props)

    window.scroll(0, 0)
  
    this.state = {
      mobileMenu: false,
      popup: true
    }
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  showPopup(hash: string): JSX.Element {
    const screenPosition = document.documentElement.scrollTop + 150
    const top = screenPosition.toString() + 'px'
    return(
      <div className="popup">
        <div className="popup-inner popup-unsubscribe" style={{ top }}>
          <h3 
            className="h3"
            style={{ textAlign: 'center', marginBottom: '30px' }}
          >
            You will no longer receive game updates, reminders and tips from The Accumulator Club - Are you sure you want to unsubscribe?
          </h3>
          <div className="form-group" style={{ display: 'inline-block', verticalAlign: 'top', width: '30%', marginLeft: '15%', marginRight: '5%' }}>
            <button 
              className="btn btn-lg btn-block btn-primary no-shadow"
              onClick={() => {
                Socket.Send('unsubscribe', {hash})
                this.setState({ popup: false })
              }}
            >
              YES
            </button>
          </div>
          <div className="form-group" style={{ display: 'inline-block', verticalAlign: 'top', width: '30%', marginLeft: '5%', marginRight: '15%' }}>
            <button className="btn btn-lg btn-block btn-primary no-shadow">
              <Link 
                to="/lounge"
                style={{ display: 'block', width: '100%', height: '100%', color: '#FFF', textDecoration: 'none' }}
              >
                NO
              </Link>
            </button>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const hash = this.getParameterByName('hash', window.location.search)
    const unsubscribe = Socket.Get<any>('unsubscribe')
    if (!this.state.popup && unsubscribe.loading !== 'loaded') {
      return <Loader/>
    } else {
      return (
        <section className="wrapper">
          <div className="navigation-main-wrapper">
            <div className="navigation-main navbar navbar-default" style={{ marginBottom: '0' }}>
              <div className="container">
                <div className="row">
                  <Link className="navbar-brand" to="/">
                    <img src="logo-main2.png" alt="" className="logo logo-acc" />
                  </Link>
                  <button
                    onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                    type="button"
                    className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'}
                    data-toggle="collapse"
                    data-target="#navbar-collapse-mid"
                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                  >
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                  </button>
                  <div className="clearfix" />
                  <nav
                    className={(this.state.mobileMenu) ? 'collapse navbar-collapse navbar-mid-bar collapse in' : 'collapse navbar-collapse navbar-mid-bar'}
                    id="navbar-collapse-mid"
                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                    style={(this.state.mobileMenu) ? { height: '220px' } : { height: '1px' }}
                  >
                    {Body.getMenu('pull-left', Assets.menuLeft)}
                    {(this.state.mobileMenu) ? Body.getMenu('pull-left', Assets.menuRight) : Body.getMenu('pull-right', Assets.menuRight)}
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <main className="main">
            <div className="container">
              <div className="panel panel-default two-column equal-height-wrapper">
                <div className="panel-left equal-height-col" style={{ padding: '50px' }}>
                  <span style={{ color: 'rgb(41, 160, 0)', fontSize: '20px' }}>
                    {(unsubscribe.unsubscribe && unsubscribe.unsubscribe.message) ?
                      'You have been unsubscribed from our mailing list.'
                    : (unsubscribe.unsubscribe && unsubscribe.unsubscribe.error) ?
                      'Your link for cancelling subscription is not valid.'
                    :
                      ''
                    }
                  </span>
                </div>
              </div>
            </div>
            {(hash && this.state.popup) ? this.showPopup(hash) : null}
          </main>
        </section>
      )
    }
  }

}

export default withCookies(Unsubscribe)


// WEBPACK FOOTER //
// ./src/Views/Main/Index/Unsubscribe.tsx